import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translations';
import SharedHeader from '../components/SharedHeader';
import SharedFooter from '../components/SharedFooter';

const AboutUs = () => {
  const { language, changeLanguage } = useLanguage();
  const t = (key) => getTranslation(language, key);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 text-white">
      <SharedHeader />

      {/* About Content */}
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Title */}
          <div className="text-center mb-12">
            <h1 className="text-5xl font-bold mb-4">
              {t('aboutTitle')}
            </h1>
            <div className="w-32 h-1 bg-yellow-400 mx-auto"></div>
          </div>

          {/* Content */}
          <div className="space-y-8 text-lg leading-relaxed">
            <p className="text-gray-200">
              {t('aboutText1')}
            </p>
            
            <p className="text-yellow-300 font-semibold text-xl text-center">
              {t('aboutText2')}
            </p>
            
            <p className="text-gray-200">
              {t('aboutText3')}
            </p>
            
            <p className="text-gray-200">
              {t('aboutText4')}
            </p>
            
            <p className="text-gray-200">
              {t('aboutText5')}
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="mt-16 flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/interes" className="bg-yellow-500 hover:bg-yellow-600 text-black text-lg px-8 py-4 w-full sm:w-auto text-center rounded-lg font-semibold transition">
              {t('registerForInvitation')}
            </Link>
            <Link to="/" className="border-2 border-white text-white hover:bg-white hover:text-purple-900 text-lg px-8 py-4 w-full sm:w-auto text-center rounded-lg font-semibold transition">
              {t('home')}
            </Link>
          </div>
        </div>
      </main>

      <SharedFooter />
    </div>
  );
};

export default AboutUs;